/** Khoa (Department) catalogue client. Real /api/v1/departments — see DepartmentController. */
import { apiClient } from "./client";

/** Dropdown shape — active departments only. */
export interface DepartmentOption {
  id: string;
  code: string;
  name: string;
}

/** Full row for the settings page (incl. inactive). */
export interface Department {
  id: string;
  code: string;
  name: string;
  description: string | null;
  sortOrder: number;
  active: boolean;
}

export interface DepartmentCreateInput {
  code: string;
  name: string;
  description?: string | null;
  sortOrder?: number | null;
}

export interface DepartmentUpdateInput {
  name: string;
  description?: string | null;
  sortOrder?: number | null;
}

export const departmentsApi = {
  /** Active departments only, for dropdowns. */
  options(): Promise<DepartmentOption[]> {
    return apiClient
      .get<DepartmentOption[]>("/v1/departments")
      .then((r) => r.data);
  },
  /** All departments (active + inactive) for the settings list. */
  listAll(): Promise<Department[]> {
    return apiClient.get<Department[]>("/v1/departments/all").then((r) => r.data);
  },
  create(req: DepartmentCreateInput): Promise<Department> {
    return apiClient.post<Department>("/v1/departments", req).then((r) => r.data);
  },
  update(id: string, req: DepartmentUpdateInput): Promise<Department> {
    return apiClient
      .put<Department>(`/v1/departments/${id}`, req)
      .then((r) => r.data);
  },
  disable(id: string): Promise<Department> {
    return apiClient
      .post<Department>(`/v1/departments/${id}/disable`)
      .then((r) => r.data);
  },
  enable(id: string): Promise<Department> {
    return apiClient
      .post<Department>(`/v1/departments/${id}/enable`)
      .then((r) => r.data);
  },
  /** Hard delete (permanent). 409 nếu khoa đang được tham chiếu. */
  remove(id: string): Promise<void> {
    return apiClient.delete(`/v1/departments/${id}/permanent`).then(() => undefined);
  },
};

export const departmentQueryKeys = {
  options: () => ["departments", "options"] as const,
  all: () => ["departments", "all"] as const,
};
